import { NgModule } from '@angular/core';
import { ReportsModule } from './reports/reports.module';
import { ReportsRoutingModule } from './reports/reports-routing.module';
import { PharmacyPeekModule } from './pharmacy-peek/pharmacy-peek.module';
import { InventoryModule } from './inventory/inventory.module' ;
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [],
  imports: [
    ReportsModule,
    PharmacyPeekModule,
    SharedModule,
    FormsModule,
    InventoryModule,
    ReactiveFormsModule,
    ReportsRoutingModule,
  ],
  exports: [
    PharmacyPeekModule,
  ],
})

export class ExternalUserModule { }
